import React from 'react';
import { SettingsContext } from '.';

function useSettings() {
  const context = React.useContext(SettingsContext);

  if (!context) {
    throw new Error(`useSettings must be used within a SettingsProvider`);
  }

  const {
    store,
    addFindsFilter,
    replaceFindsFilter,
    disableFindsFilter,
    setMainDrawerIndex,
    setSelectedEntity,
    setSelectedObject,
    updateFindsFilter,
    toggleFindLayer,
    toggleHeatmapLayer,
    toggleIsadLayer,
    toggleLpisLayer,
    toggleObjectLayer,
    toggleObjectsMapVisibility,
    toggleParentsMapVisibility,
    toggleMapDrawer,
    setFindVisualization,
    toggleVisualizationDefaults,
    setFindSettingsExpanded,
    applyFindVisualization,
  } = context;

  return {
    store,
    addFindsFilter,
    replaceFindsFilter,
    disableFindsFilter,
    setMainDrawerIndex,
    setSelectedEntity,
    setSelectedObject,
    updateFindsFilter,
    toggleFindLayer,
    toggleHeatmapLayer,
    toggleIsadLayer,
    toggleLpisLayer,
    toggleObjectLayer,
    toggleObjectsMapVisibility,
    toggleParentsMapVisibility,
    toggleMapDrawer,
    setFindVisualization,
    toggleVisualizationDefaults,
    setFindSettingsExpanded,
    applyFindVisualization,
  };
}

export { useSettings };
